import styled from 'styled-components';

export const Container = styled.div`
    height: 90%;
    position: relative;

    .ql-container{
        border: none;
    }

    .ql-editor {
        background: ${(props) => props.theme.richTextBox.editor.background};
        border: 1px solid ${(props) => (props.hasError 
            ? props.theme.colors.borderErrorColor 
            : 'none'
        )};
        border-radius: 10px;
        color: ${(props) => props.theme.richTextBox.editor.color};
        padding: 30px 15px 15px 15px;
        line-height: 2.5rem;
    }
    .ql-editor.ql-blank::before{
        color:${(props) => props.theme.richTextBox.editor.placeHolder};
     }
`;
